// extracted by mini-css-extract-plugin
export var Timeline = "Timeline-module--Timeline--abb4e";
export var TimelineBox = "Timeline-module--TimelineBox--ea907";
export var TimelineGroup = "Timeline-module--TimelineGroup--71932";
export var TimelineItem = "Timeline-module--TimelineItem--98b90";
export var TimelineYearPointer = "Timeline-module--TimelineYearPointer--efa02";